// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z7rq","rootNoMargin":"styles_rootNoMargin__1djpy"};